var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarousel(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 12,
    viewBox: "0 0 27 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12H1.5C2.59375 12 3.5 11.125 3.5 10V2C3.5 0.90625 2.59375 0 1.5 0H0V1.5H1.5C1.75 1.5 2 1.75 2 2V10C2 10.2812 1.75 10.5 1.5 10.5H0V12ZM27 0H25.5C24.375 0 23.5 0.90625 23.5 2V10C23.5 11.125 24.375 12 25.5 12H27V10.5H25.5C25.2188 10.5 25 10.2812 25 10V2C25 1.75 25.2188 1.5 25.5 1.5H27V0ZM7.5 1.5H19.5C19.75 1.5 20 1.75 20 2V10C20 10.2812 19.75 10.5 19.5 10.5H7.5C7.21875 10.5 7 10.2812 7 10V2C7 1.75 7.21875 1.5 7.5 1.5ZM19.5 0H7.5C6.375 0 5.5 0.90625 5.5 2V10C5.5 11.125 6.375 12 7.5 12H19.5C20.5938 12 21.5 11.125 21.5 10V2C21.5 0.90625 20.5938 0 19.5 0Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarousel);
export default __webpack_public_path__ + "static/media/carousel.8d1728dec748fa5871ea8f0253f537e5.svg";
export { ForwardRef as ReactComponent };